/**
 * EN-1517: who may cancel or retry a download from the Download Sessions
 * panel. Cancel (POST /download-commands/cancel, EN-1515) and retry
 * (POST /download-sessions/retry, EN-1506) need the same permission as
 * queueing a download (POST /commands/queue): a company admin or super admin.
 * The WebApi returns 403 to anyone else.
 */

import type { IUser } from '../models/User';
import { hasAnyRole } from './AuthGuard';

/** Short message for a 403 from cancel or retry. */
export const NO_PERMISSION_MESSAGE = "You don't have permission to do that.";

/**
 * The admin gate for the panel's Cancel and Retry: the same check as the
 * EN-1516 Download Manager button, hasAnyRole(user, 'admin', 'superadmin')
 * (src/utils/AuthGuard.ts), so the two never disagree. It reads the roles
 * array (a multi-role user counts, like the WebApi's isAdministrator()) and
 * compares exactly.
 */
export function canManageDownloads(user: IUser | null | undefined): boolean {
  return hasAnyRole(user, 'admin', 'superadmin');
}

/** True for an axios (or axios-like) error whose response is 403 Forbidden. */
export function isForbiddenError(error: unknown): boolean {
  return (error as any)?.response?.status === 403;
}
